import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import React from 'react'
import { RootState } from '../../store/store'
import { log } from '../../utils/logger'
import dayjs from 'dayjs'

interface IPrivateRouteProps {
  Component: React.ComponentType
}

function PrivateRoute({ Component }: IPrivateRouteProps): JSX.Element {
  const authStore = useSelector((state: RootState) => state.auth)
  const { token, expirationTime } = authStore
  if (!expirationTime) {
    log.debug(`[PrivateRoute] no expirationTime`)
    return <Navigate to='/login' />
  }

  if (!token) {
    log.debug(`[PrivateRoute] no token`)
    return <Navigate to='/login' />
  }

  console.log(`expirationTime`, dayjs(expirationTime).format(`YYYY-MM-DD HH:mm`))
  console.log(`token`, token)
  const expiration = dayjs(expirationTime)
  const now = dayjs()
  if (now.isAfter(expiration.add(8, 'hours'))) {
    log.debug(`[PrivateRoute] Token too old. Better redo a login`)
    return <Navigate to='/login' />
  }

  return <Component />
}
export { PrivateRoute }
